<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="input-section form-section" style="margin-right: 56px;">
              <label>
                <strong>
                  <span class="mr-1">11.</span>
                Complete the following for all types of properties appraised and/or sold, and indicate gross income
derived from each:
                </strong>
              </label>
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th colspan="2">Last 12 Months</th>
                    <th colspan="2">Projected Next 12 Months</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th>$ Gross Revenue</th>
                    <th># of Appraisals / Transactions</th>
                    <th>$ Gross Revenue</th>
                    <th># of Appraisals / Transactions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th colspan="5">RESIDENTIAL Appraisal Assignments</th>
                  </tr>
                  <tr>
                    <td>
                      Single-family residential or lots for single-family residential (1 to 4 units)
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueSingleFamily"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueSingleFamily"
                      >
                      <span
                        v-show="errors.has('lastRevenueSingleFamily')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueSingleFamily') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberSingleFamily"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberSingleFamily"
                      >
                      <span
                        v-show="errors.has('lastNumberSingleFamily')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberSingleFamily') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueSingleFamily"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueSingleFamily"
                      >
                      <span
                        v-show="errors.has('nextRevenueSingleFamily')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueSingleFamily') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberSingleFamily"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberSingleFamily"
                      >
                      <span
                        v-show="errors.has('nextNumberSingleFamily')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberSingleFamily') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Multi-family (5 to 9 units) or lots for multi-family (5 to 9 units)
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueMultiFamily"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueMultiFamily"
                      >
                      <span
                        v-show="errors.has('lastRevenueMultiFamily')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueMultiFamily') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberMultiFamily"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberMultiFamily"
                      >
                      <span
                        v-show="errors.has('lastNumberMultiFamily')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberMultiFamily') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueMultiFamily"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueMultiFamily"
                      >
                      <span
                        v-show="errors.has('nextRevenueMultiFamily')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueMultiFamily') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberMultiFamily"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberMultiFamily"
                      >
                      <span
                        v-show="errors.has('nextNumberMultiFamily')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberMultiFamily') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalLastRevenueResidentialAppraisal"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalLastNumberResidentialAppraisal"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalNextRevenueResidentialAppraisal"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalNextNumberResidentialAppraisal"
                        disabled
                      >
                    </td>
                  </tr>

                  <tr>
                    <th colspan="5">COMMERCIAL Appraisal Assignments</th>
                  </tr>
                  <tr>
                    <td>
                      Apartment or residential condo complexes (10 or more units)
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueResidentalCondo"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueResidentalCondo"
                      >
                      <span
                        v-show="errors.has('lastRevenueResidentalCondo')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueResidentalCondo') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberResidentalCondo"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberResidentalCondo"
                      >
                      <span
                        v-show="errors.has('lastNumberResidentalCondo')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberResidentalCondo') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueResidentalCondo"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueResidentalCondo"
                      >
                      <span
                        v-show="errors.has('nextRevenueResidentalCondo')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueResidentalCondo') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberResidentalCondo"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberResidentalCondo"
                      >
                      <span
                        v-show="errors.has('nextNumberResidentalCondo')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberResidentalCondo') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Commercial properties (shopping centers, industrial properties, office buildings, churches, schools, farm land, agricultural properties)
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueCommercialProperties"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueCommercialProperties"
                      >
                      <span
                        v-show="errors.has('lastRevenueCommercialProperties')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueCommercialProperties') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberCommercialProperties"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberCommercialProperties"
                      >
                      <span
                        v-show="errors.has('lastNumberCommercialProperties')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberCommercialProperties') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueCommercialProperties"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueCommercialProperties"
                      >
                      <span
                        v-show="errors.has('nextRevenueCommercialProperties')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueCommercialProperties') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberCommercialProperties"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberCommercialProperties"
                      >
                      <span
                        v-show="errors.has('nextNumberCommercialProperties')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberCommercialProperties') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalLastRevenueCommercialAppraisal"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalLastNumberCommercialAppraisal"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalNextRevenueCommercialAppraisal"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalNextNumberCommercialAppraisal"
                        disabled
                      >
                    </td>
                  </tr>

                  <tr>
                    <th colspan="5">Real Estate Sales / Brokering</th>
                  </tr>
                  <tr>
                    <td>
                      Farm land / Raw land
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueFarmLand"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueFarmLand"
                      >
                      <span
                        v-show="errors.has('lastRevenueFarmLand')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueFarmLand') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberFarmLand"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberFarmLand"
                      >
                      <span
                        v-show="errors.has('lastNumberFarmLand')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberFarmLand') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueFarmLand"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueFarmLand"
                      >
                      <span
                        v-show="errors.has('nextRevenueFarmLand')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueFarmLand') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberFarmLand"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberFarmLand"
                      >
                      <span
                        v-show="errors.has('nextNumberFarmLand')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberFarmLand') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Residential Sales
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueResidentialSales"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueResidentialSales"
                      >
                      <span
                        v-show="errors.has('lastRevenueResidentialSales')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueResidentialSales') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberResidentialSales"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberResidentialSales"
                      >
                      <span
                        v-show="errors.has('lastNumberResidentialSales')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberResidentialSales') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueResidentialSales"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueResidentialSales"
                      >
                      <span
                        v-show="errors.has('nextRevenueResidentialSales')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueResidentialSales') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberResidentialSales"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberResidentialSales"
                      >
                      <span
                        v-show="errors.has('nextNumberResidentialSales')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberResidentialSales') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Residential Leasing*
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueResidentialLeasing"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueResidentialLeasing"
                      >
                      <span
                        v-show="errors.has('lastRevenueResidentialLeasing')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueResidentialLeasing') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberResidentialLeasing"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberResidentialLeasing"
                      >
                      <span
                        v-show="errors.has('lastNumberResidentialLeasing')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberResidentialLeasing') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueResidentialLeasing"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueResidentialLeasing"
                      >
                      <span
                        v-show="errors.has('nextRevenueResidentialLeasing')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueResidentialLeasing') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberResidentialLeasing"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberResidentialLeasing"
                      >
                      <span
                        v-show="errors.has('nextNumberResidentialLeasing')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberResidentialLeasing') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Owned Residential Property Sales
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueOwnedResidentialProperty"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueOwnedResidentialProperty"
                      >
                      <span
                        v-show="errors.has('lastRevenueOwnedResidentialProperty')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueOwnedResidentialProperty') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberOwnedResidentialProperty"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberOwnedResidentialProperty"
                      >
                      <span
                        v-show="errors.has('lastNumberOwnedResidentialProperty')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberOwnedResidentialProperty') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueOwnedResidentialProperty"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueOwnedResidentialProperty"
                      >
                      <span
                        v-show="errors.has('nextRevenueOwnedResidentialProperty')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueOwnedResidentialProperty') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberOwnedResidentialProperty"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberOwnedResidentialProperty"
                      >
                      <span
                        v-show="errors.has('nextNumberOwnedResidentialProperty')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberOwnedResidentialProperty') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Commercial Sales*
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueCommercialSales"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueCommercialSales"
                      >
                      <span
                        v-show="errors.has('lastRevenueCommercialSales')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueCommercialSales') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberCommercialSales"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberCommercialSales"
                      >
                      <span
                        v-show="errors.has('lastNumberCommercialSales')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberCommercialSales') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueCommercialSales"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueCommercialSales"
                      >
                      <span
                        v-show="errors.has('nextRevenueCommercialSales')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueCommercialSales') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberCommercialSales"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberCommercialSales"
                      >
                      <span
                        v-show="errors.has('nextNumberCommercialSales')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberCommercialSales') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Commercial Leasing*
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueCommercialLeasing"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueCommercialLeasing"
                      >
                      <span
                        v-show="errors.has('lastRevenueCommercialLeasing')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueCommercialLeasing') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberCommercialLeasing"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberCommercialLeasing"
                      >
                      <span
                        v-show="errors.has('lastNumberCommercialLeasing')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberCommercialLeasing') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueCommercialLeasing"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueCommercialLeasing"
                      >
                      <span
                        v-show="errors.has('nextRevenueCommercialLeasing')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueCommercialLeasing') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberCommercialLeasing"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberCommercialLeasing"
                      >
                      <span
                        v-show="errors.has('nextNumberCommercialLeasing')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberCommercialLeasing') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Owned Commercial Property Sales
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueOwnedCommercialProperty"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueOwnedCommercialProperty"
                      >
                      <span
                        v-show="errors.has('lastRevenueOwnedCommercialProperty')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueOwnedCommercialProperty') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberOwnedCommercialProperty"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberOwnedCommercialProperty"
                      >
                      <span
                        v-show="errors.has('lastNumberOwnedCommercialProperty')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberOwnedCommercialProperty') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueOwnedCommercialProperty"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueOwnedCommercialProperty"
                      >
                      <span
                        v-show="errors.has('nextRevenueOwnedCommercialProperty')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueOwnedCommercialProperty') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberOwnedCommercialProperty"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberOwnedCommercialProperty"
                      >
                      <span
                        v-show="errors.has('nextNumberOwnedCommercialProperty')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberOwnedCommercialProperty') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalLastRevenueRealEstateSales"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalLastNumberRealEstateSales"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalNextRevenueRealEstateSales"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalNextNumberRealEstateSales"
                        disabled
                      >
                    </td>
                  </tr>

                  <tr>
                    <th colspan="5">Other Services</th>
                  </tr>
                  <tr>
                    <td>
                      Property Management
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenuePropertyManagement"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenuePropertyManagement"
                      >
                      <span
                        v-show="errors.has('lastRevenuePropertyManagement')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenuePropertyManagement') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberPropertyManagement"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberPropertyManagement"
                      >
                      <span
                        v-show="errors.has('lastNumberPropertyManagement')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberPropertyManagement') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenuePropertyManagement"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenuePropertyManagement"
                      >
                      <span
                        v-show="errors.has('nextRevenuePropertyManagement')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenuePropertyManagement') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberPropertyManagement"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberPropertyManagement"
                      >
                      <span
                        v-show="errors.has('nextNumberPropertyManagement')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberPropertyManagement') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Sale of Business Opportunities
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueSalesOfBusiness"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueSalesOfBusiness"
                      >
                      <span
                        v-show="errors.has('lastRevenueSalesOfBusiness')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueSalesOfBusiness') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberSalesOfBusiness"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberSalesOfBusiness"
                      >
                      <span
                        v-show="errors.has('lastNumberSalesOfBusiness')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberSalesOfBusiness') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueSalesOfBusiness"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueSalesOfBusiness"
                      >
                      <span
                        v-show="errors.has('nextRevenueSalesOfBusiness')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueSalesOfBusiness') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberSalesOfBusiness"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberSalesOfBusiness"
                      >
                      <span
                        v-show="errors.has('nextNumberSalesOfBusiness')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberSalesOfBusiness') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Mortgage Brokering
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueMortgageBrokering"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueMortgageBrokering"
                      >
                      <span
                        v-show="errors.has('lastRevenueMortgageBrokering')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueMortgageBrokering') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberMortgageBrokering"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberMortgageBrokering"
                      >
                      <span
                        v-show="errors.has('lastNumberMortgageBrokering')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberMortgageBrokering') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueMortgageBrokering"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueMortgageBrokering"
                      >
                      <span
                        v-show="errors.has('nextRevenueMortgageBrokering')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueMortgageBrokering') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberMortgageBrokering"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberMortgageBrokering"
                      >
                      <span
                        v-show="errors.has('nextNumberMortgageBrokering')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberMortgageBrokering') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Real Estate Consulting (provide details below)
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueRealEstateConsulting"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueRealEstateConsulting"
                      >
                      <span
                        v-show="errors.has('lastRevenueRealEstateConsulting')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueRealEstateConsulting') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberRealEstateConsulting"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberRealEstateConsulting"
                      >
                      <span
                        v-show="errors.has('lastNumberRealEstateConsulting')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberRealEstateConsulting') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueRealEstateConsulting"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueRealEstateConsulting"
                      >
                      <span
                        v-show="errors.has('nextRevenueRealEstateConsulting')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueRealEstateConsulting') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberRealEstateConsulting"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberRealEstateConsulting"
                      >
                      <span
                        v-show="errors.has('nextNumberRealEstateConsulting')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberRealEstateConsulting') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Other (provide details below)
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastRevenueOther"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastRevenueOther"
                      >
                      <span
                        v-show="errors.has('lastRevenueOther')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastRevenueOther') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="lastNumberOther"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="lastNumberOther"
                      >
                      <span
                        v-show="errors.has('lastNumberOther')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('lastNumberOther') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextRevenueOther"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextRevenueOther"
                      >
                      <span
                        v-show="errors.has('nextRevenueOther')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextRevenueOther') | filterText }}</span>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        name="nextNumberOther"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="nextNumberOther"
                      >
                      <span
                        v-show="errors.has('nextNumberOther')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('nextNumberOther') | filterText }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalLastRevenueOtherServices"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalLastNumberOtherServices"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalNextRevenueOtherServices"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalNextNumberOtherServices"
                        disabled
                      >
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Total</strong></td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalLastRevenue"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalLastNumber"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalNextRevenue"
                        disabled
                      >
                    </td>
                    <td>
                      <input
                        type="text"
                        class="orep-text-input"
                        v-model="totalNextNumber"
                        disabled
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label mb-0">
                Details of "Real Estate Consulting" and "Other" from above (if applicable):
              </label>
              <div>
                <input
                  type="text"
                  class="mt-1 mb-1 orep-text-input"
                  name="detailsOfRealEstate1"
                  v-model="groupAppraiser.detailsOfRealEstate1"
                >
              </div>
              <input
                type="text"
                class="mt-1 mb-1 orep-text-input"
                name="detailsOfRealEstate2"
                v-model="groupAppraiser.detailsOfRealEstate2"
              >
              <input
                type="text"
                class="mt-1 mb-1 orep-text-input"
                name="detailsOfRealEstate3"
                v-model="groupAppraiser.detailsOfRealEstate3"
              >
            </article>
            <article class="input-section form-section">
              <div class="flex">
                <div class="col-md-9">
                  <label for class="orep-label">
                    <span class="mr-1">12.</span>
                    Do you appraise any real estate or properties which you have a financial interest in?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doYouAppraiseAnyRealEstate"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="groupAppraiser.doYouAppraiseAnyRealEstate"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doYouAppraiseAnyRealEstate"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="groupAppraiser.doYouAppraiseAnyRealEstate"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('doYouAppraiseAnyRealEstate')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('doYouAppraiseAnyRealEstate') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="flex">
                <div class="col-md-9">
                  <label for class="orep-label">
                    <span class="mr-1">13.</span>
                    Do you perform appraisals on properties valued over $3,000,000?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doYouPerformAppraisalsOnProperties"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="groupAppraiser.doYouPerformAppraisalsOnProperties"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doYouPerformAppraisalsOnProperties"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="groupAppraiser.doYouPerformAppraisalsOnProperties"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('doYouPerformAppraisalsOnProperties')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('doYouPerformAppraisalsOnProperties') | filterText }}</span>
                </div>
              </div>
              <input
                type="text"
                placeholder="Please indicate highest value property appraised in last 12 months:"
                class="orep-text-input js-orep-input"
                v-if="groupAppraiser.doYouPerformAppraisalsOnProperties === 'true' || groupAppraiser.doYouPerformAppraisalsOnProperties == true"
                name="doesApplicantControlInOtherBusinessDetails"
                v-model="groupAppraiser.doYouPerformAppraisalsOnPropertiesDetails"
              >
            </article>
            <article class="input-section form-section">
              <div class="flex">
                <div class="col-md-9">
                  <label for class="orep-label">
                    <span class="mr-1">14.</span>
                    During the past 5 years has the applicant been involved in any merger, acquisition, or consolidation?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasApplicantBeenInvolvedInAnyMerger"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="groupAppraiser.hasApplicantBeenInvolvedInAnyMerger"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasApplicantBeenInvolvedInAnyMerger"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="groupAppraiser.hasApplicantBeenInvolvedInAnyMerger"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('hasApplicantBeenInvolvedInAnyMerger')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('hasApplicantBeenInvolvedInAnyMerger') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section d-flex flex-column">
              <div class="flex">
                <div class="col-md-9">
                  <label for class="orep-label">
                    <span class="mr-1">15.</span>
                    Does the applicant transact business in multiple states or outside of the United States?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantTransactBusinessInMultipleStates"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="groupAppraiser.doesApplicantTransactBusinessInMultipleStates"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantTransactBusinessInMultipleStates"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="groupAppraiser.doesApplicantTransactBusinessInMultipleStates"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('doesApplicantTransactBusinessInMultipleStates')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('doesApplicantTransactBusinessInMultipleStates') | filterText }}</span>
                </div>
              </div>
              <p v-if="groupAppraiser.doesApplicantTransactBusinessInMultipleStates == true || groupAppraiser.doesApplicantTransactBusinessInMultipleStates === 'true'" class="mb-0 ml-3 font-weight-bold">
                Provide details on a separate sheet, including the percent (%) of total gross revenues from each
state or country.
              </p>
            </article>
            <article class="input-section form-section">
              <div class="flex">
                <div class="col-md-9">
                  <label for class="orep-label">
                    <span class="mr-1">16.</span>
                    Would you like coverage for both appraising and sales/leasing under this policy?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="wouldLikeCoverageForBothAppraisingAndSales"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="groupAppraiser.wouldLikeCoverageForBothAppraisingAndSales"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="wouldLikeCoverageForBothAppraisingAndSales"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="groupAppraiser.wouldLikeCoverageForBothAppraisingAndSales"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('wouldLikeCoverageForBothAppraisingAndSales')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('wouldLikeCoverageForBothAppraisingAndSales') | filterText }}</span>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-md-12">
        <section class="flex wrap bottom-section">
          <router-link :to="{name:'group-appraiser-1'}" class="next-btn back-btn flex mont spaced">
            <i class="fas fa-arrow-left"></i>
            Back
          </router-link>
          <article class="orep-pagination">
            <button @click="prev()" class="pagination-dots"></button>
            <button class="pagination-dots pagination-current"></button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid"
              @click="navigateToNext('group-appraiser-3')">
            </button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid"
              @click="navigateToNext('pageTwoIsValid-appraiser-4')">
            </button>
          </article>
          <button type="submit" :disabled="!state.pageTwoIsValid"
            :class="{submitDisabled: !state.pageTwoIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('group-appraiser-3')">Next</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "group-appraiser-2",
  computed: {
    groupAppraiser() {
      return this.$store.state.groupAppraiser.groupAppraiser;
    },
    state() {
      return this.$store.state.groupAppraiser;
    },
    errorMsg() {
      return this.$store.state.groupAppraiser.errorMsg;
    },
    lastRevenueSingleFamily: {
      get: function() {
        return this.groupAppraiser.lastRevenueSingleFamily || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueSingleFamily = val;
      }
    },
    lastRevenueMultiFamily: {
      get: function() {
        return this.groupAppraiser.lastRevenueMultiFamily || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueMultiFamily = val;
      }
    },
    totalLastRevenueResidentialAppraisal() {
      return (Number(this.groupAppraiser.lastRevenueSingleFamily) + Number(this.groupAppraiser.lastRevenueMultiFamily)).toFixed(0);
    },
    lastNumberSingleFamily: {
      get: function() {
        return this.groupAppraiser.lastNumberSingleFamily || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberSingleFamily = val;
      }
    },
    lastNumberMultiFamily: {
      get: function() {
        return this.groupAppraiser.lastNumberMultiFamily || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberMultiFamily = val;
      }
    },
    totalLastNumberResidentialAppraisal() {
      return (Number(this.groupAppraiser.lastNumberSingleFamily) + Number(this.groupAppraiser.lastNumberMultiFamily)).toFixed(0);
    },
    nextRevenueSingleFamily: {
      get: function() {
        return this.groupAppraiser.nextRevenueSingleFamily || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueSingleFamily = val;
      }
    },
    nextRevenueMultiFamily: {
      get: function() {
        return this.groupAppraiser.nextRevenueMultiFamily || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueMultiFamily = val;
      }
    },
    totalNextRevenueResidentialAppraisal() {
      return (Number(this.groupAppraiser.nextRevenueSingleFamily) + Number(this.groupAppraiser.nextRevenueMultiFamily)).toFixed(0);
    },
    nextNumberSingleFamily: {
      get: function() {
        return this.groupAppraiser.nextNumberSingleFamily || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberSingleFamily = val;
      }
    },
    nextNumberMultiFamily: {
      get: function() {
        return this.groupAppraiser.nextNumberMultiFamily || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberMultiFamily = val;
      }
    },
    totalNextNumberResidentialAppraisal() {
      return (Number(this.groupAppraiser.nextNumberSingleFamily) + Number(this.groupAppraiser.nextNumberMultiFamily)).toFixed(0);
    },
    lastRevenueResidentalCondo: {
      get: function() {
        return this.groupAppraiser.lastRevenueResidentalCondo || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueResidentalCondo = val;
      }
    },
    lastRevenueCommercialProperties: {
      get: function() {
        return this.groupAppraiser.lastRevenueCommercialProperties || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueCommercialProperties = val;
      }
    },
    totalLastRevenueCommercialAppraisal() {
      return (Number(this.groupAppraiser.lastRevenueResidentalCondo) + Number(this.groupAppraiser.lastRevenueCommercialProperties)).toFixed(0);
    },
    lastNumberResidentalCondo: {
      get: function() {
        return this.groupAppraiser.lastNumberResidentalCondo || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberResidentalCondo = val;
      }
    },
    lastNumberCommercialProperties: {
      get: function() {
        return this.groupAppraiser.lastNumberCommercialProperties || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberCommercialProperties = val;
      }
    },
    totalLastNumberCommercialAppraisal() {
      return (Number(this.groupAppraiser.lastNumberResidentalCondo) + Number(this.groupAppraiser.lastNumberCommercialProperties)).toFixed(0);
    },
    nextRevenueResidentalCondo: {
      get: function() {
        return this.groupAppraiser.nextRevenueResidentalCondo || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueResidentalCondo = val;
      }
    },
    nextRevenueCommercialProperties: {
      get: function() {
        return this.groupAppraiser.nextRevenueCommercialProperties || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueCommercialProperties = val;
      }
    },
    totalNextRevenueCommercialAppraisal() {
      return (Number(this.groupAppraiser.nextRevenueResidentalCondo) + Number(this.groupAppraiser.nextRevenueCommercialProperties)).toFixed(0);
    },
    nextNumberResidentalCondo: {
      get: function() {
        return this.groupAppraiser.nextNumberResidentalCondo || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberResidentalCondo = val;
      }
    },
    nextNumberCommercialProperties: {
      get: function() {
        return this.groupAppraiser.nextNumberCommercialProperties || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberCommercialProperties = val;
      }
    },
    totalNextNumberCommercialAppraisal() {
      return (Number(this.groupAppraiser.nextNumberResidentalCondo) + Number(this.groupAppraiser.nextNumberCommercialProperties)).toFixed(0);
    },
    lastRevenueFarmLand: {
      get: function() {
        return this.groupAppraiser.lastRevenueFarmLand || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueFarmLand = val;
      }
    },
    lastRevenueResidentialSales: {
      get: function() {
        return this.groupAppraiser.lastRevenueResidentialSales || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueResidentialSales = val;
      }
    },
    lastRevenueResidentialLeasing: {
      get: function() {
        return this.groupAppraiser.lastRevenueResidentialLeasing || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueResidentialLeasing = val;
      }
    },
    lastRevenueOwnedResidentialProperty: {
      get: function() {
        return this.groupAppraiser.lastRevenueOwnedResidentialProperty || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueOwnedResidentialProperty = val;
      }
    },
    lastRevenueCommercialSales: {
      get: function() {
        return this.groupAppraiser.lastRevenueCommercialSales || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueCommercialSales = val;
      }
    },
    lastRevenueCommercialLeasing: {
      get: function() {
        return this.groupAppraiser.lastRevenueCommercialLeasing || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueCommercialLeasing = val;
      }
    },
    lastRevenueOwnedCommercialProperty: {
      get: function() {
        return this.groupAppraiser.lastRevenueOwnedCommercialProperty || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueOwnedCommercialProperty = val;
      }
    },
    totalLastRevenueRealEstateSales() {
      return (
        Number(this.groupAppraiser.lastRevenueFarmLand) +
        Number(this.groupAppraiser.lastRevenueResidentialSales) +
        Number(this.groupAppraiser.lastRevenueResidentialLeasing) +
        Number(this.groupAppraiser.lastRevenueOwnedResidentialProperty) +
        Number(this.groupAppraiser.lastRevenueCommercialSales) +
        Number(this.groupAppraiser.lastRevenueCommercialLeasing) +
        Number(this.groupAppraiser.lastRevenueOwnedCommercialProperty)
      ).toFixed(0);
    },
    lastNumberFarmLand: {
      get: function() {
        return this.groupAppraiser.lastNumberFarmLand || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberFarmLand = val;
      }
    },
    lastNumberResidentialSales: {
      get: function() {
        return this.groupAppraiser.lastNumberResidentialSales || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberResidentialSales = val;
      }
    },
    lastNumberResidentialLeasing: {
      get: function() {
        return this.groupAppraiser.lastNumberResidentialLeasing || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberResidentialLeasing = val;
      }
    },
    lastNumberOwnedResidentialProperty: {
      get: function() {
        return this.groupAppraiser.lastNumberOwnedResidentialProperty || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberOwnedResidentialProperty = val;
      }
    },
    lastNumberCommercialSales: {
      get: function() {
        return this.groupAppraiser.lastNumberCommercialSales || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberCommercialSales = val;
      }
    },
    lastNumberCommercialLeasing: {
      get: function() {
        return this.groupAppraiser.lastNumberCommercialLeasing || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberCommercialLeasing = val;
      }
    },
    lastNumberOwnedCommercialProperty: {
      get: function() {
        return this.groupAppraiser.lastNumberOwnedCommercialProperty || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberOwnedCommercialProperty = val;
      }
    },
    totalLastNumberRealEstateSales() {
      return (
        Number(this.groupAppraiser.lastNumberFarmLand) +
        Number(this.groupAppraiser.lastNumberResidentialSales) +
        Number(this.groupAppraiser.lastNumberResidentialLeasing) +
        Number(this.groupAppraiser.lastNumberOwnedResidentialProperty) +
        Number(this.groupAppraiser.lastNumberCommercialSales) +
        Number(this.groupAppraiser.lastNumberCommercialLeasing) +
        Number(this.groupAppraiser.lastNumberOwnedCommercialProperty)
      ).toFixed(0);
    },
    nextRevenueFarmLand: {
      get: function() {
        return this.groupAppraiser.nextRevenueFarmLand || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueFarmLand = val;
      }
    },
    nextRevenueResidentialSales: {
      get: function() {
        return this.groupAppraiser.nextRevenueResidentialSales || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueResidentialSales = val;
      }
    },
    nextRevenueResidentialLeasing: {
      get: function() {
        return this.groupAppraiser.nextRevenueResidentialLeasing || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueResidentialLeasing = val;
      }
    },
    nextRevenueOwnedResidentialProperty: {
      get: function() {
        return this.groupAppraiser.nextRevenueOwnedResidentialProperty || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueOwnedResidentialProperty = val;
      }
    },
    nextRevenueCommercialSales: {
      get: function() {
        return this.groupAppraiser.nextRevenueCommercialSales || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueCommercialSales = val;
      }
    },
    nextRevenueCommercialLeasing: {
      get: function() {
        return this.groupAppraiser.nextRevenueCommercialLeasing || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueCommercialLeasing = val;
      }
    },
    nextRevenueOwnedCommercialProperty: {
      get: function() {
        return this.groupAppraiser.nextRevenueOwnedCommercialProperty || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueOwnedCommercialProperty = val;
      }
    },
    totalNextRevenueRealEstateSales() {
      return (
        Number(this.groupAppraiser.nextRevenueFarmLand) +
        Number(this.groupAppraiser.nextRevenueResidentialSales) +
        Number(this.groupAppraiser.nextRevenueResidentialLeasing) +
        Number(this.groupAppraiser.nextRevenueOwnedResidentialProperty) +
        Number(this.groupAppraiser.nextRevenueCommercialSales) +
        Number(this.groupAppraiser.nextRevenueCommercialLeasing) +
        Number(this.groupAppraiser.nextRevenueOwnedCommercialProperty)
      ).toFixed(0);
    },
    nextNumberFarmLand: {
      get: function() {
        return this.groupAppraiser.nextNumberFarmLand || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberFarmLand = val;
      }
    },
    nextNumberResidentialSales: {
      get: function() {
        return this.groupAppraiser.nextNumberResidentialSales || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberResidentialSales = val;
      }
    },
    nextNumberResidentialLeasing: {
      get: function() {
        return this.groupAppraiser.nextNumberResidentialLeasing || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberResidentialLeasing = val;
      }
    },
    nextNumberOwnedResidentialProperty: {
      get: function() {
        return this.groupAppraiser.nextNumberOwnedResidentialProperty || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberOwnedResidentialProperty = val;
      }
    },
    nextNumberCommercialSales: {
      get: function() {
        return this.groupAppraiser.nextNumberCommercialSales || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberCommercialSales = val;
      }
    },
    nextNumberCommercialLeasing: {
      get: function() {
        return this.groupAppraiser.nextNumberCommercialLeasing || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberCommercialLeasing = val;
      }
    },
    nextNumberOwnedCommercialProperty: {
      get: function() {
        return this.groupAppraiser.nextNumberOwnedCommercialProperty || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberOwnedCommercialProperty = val;
      }
    },
    totalNextNumberRealEstateSales() {
      return (
        Number(this.groupAppraiser.nextNumberFarmLand) +
        Number(this.groupAppraiser.nextNumberResidentialSales) +
        Number(this.groupAppraiser.nextNumberResidentialLeasing) +
        Number(this.groupAppraiser.nextNumberOwnedResidentialProperty) +
        Number(this.groupAppraiser.nextNumberCommercialSales) +
        Number(this.groupAppraiser.nextNumberCommercialLeasing) +
        Number(this.groupAppraiser.nextNumberOwnedCommercialProperty)
      ).toFixed(0);
    },
    lastRevenuePropertyManagement: {
      get: function() {
        return this.groupAppraiser.lastRevenuePropertyManagement || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenuePropertyManagement = val;
      }
    },
    lastRevenueSalesOfBusiness: {
      get: function() {
        return this.groupAppraiser.lastRevenueSalesOfBusiness || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueSalesOfBusiness = val;
      }
    },
    lastRevenueMortgageBrokering: {
      get: function() {
        return this.groupAppraiser.lastRevenueMortgageBrokering || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueMortgageBrokering = val;
      }
    },
    lastRevenueRealEstateConsulting: {
      get: function() {
        return this.groupAppraiser.lastRevenueRealEstateConsulting || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueRealEstateConsulting = val;
      }
    },
    lastRevenueOther: {
      get: function() {
        return this.groupAppraiser.lastRevenueOther || '';
      },
      set: function(val) {
        this.groupAppraiser.lastRevenueOther = val;
      }
    },
    totalLastRevenueOtherServices() {
      return (
        Number(this.groupAppraiser.lastRevenuePropertyManagement) +
        Number(this.groupAppraiser.lastRevenueSalesOfBusiness) +
        Number(this.groupAppraiser.lastRevenueMortgageBrokering) +
        Number(this.groupAppraiser.lastRevenueRealEstateConsulting) +
        Number(this.groupAppraiser.lastRevenueOther)
      ).toFixed(0);
    },
    lastNumberPropertyManagement: {
      get: function() {
        return this.groupAppraiser.lastNumberPropertyManagement || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberPropertyManagement = val;
      }
    },
    lastNumberSalesOfBusiness: {
      get: function() {
        return this.groupAppraiser.lastNumberSalesOfBusiness || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberSalesOfBusiness = val;
      }
    },
    lastNumberMortgageBrokering: {
      get: function() {
        return this.groupAppraiser.lastNumberMortgageBrokering || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberMortgageBrokering = val;
      }
    },
    lastNumberRealEstateConsulting: {
      get: function() {
        return this.groupAppraiser.lastNumberRealEstateConsulting || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberRealEstateConsulting = val;
      }
    },
    lastNumberOther: {
      get: function() {
        return this.groupAppraiser.lastNumberOther || '';
      },
      set: function(val) {
        this.groupAppraiser.lastNumberOther = val;
      }
    },
    totalLastNumberOtherServices() {
      return (
        Number(this.groupAppraiser.lastNumberPropertyManagement) +
        Number(this.groupAppraiser.lastNumberSalesOfBusiness) +
        Number(this.groupAppraiser.lastNumberMortgageBrokering) +
        Number(this.groupAppraiser.lastNumberRealEstateConsulting) +
        Number(this.groupAppraiser.lastNumberOther)
      ).toFixed(0);
    },
    nextRevenuePropertyManagement: {
      get: function() {
        return this.groupAppraiser.nextRevenuePropertyManagement || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenuePropertyManagement = val;
      }
    },
    nextRevenueSalesOfBusiness: {
      get: function() {
        return this.groupAppraiser.nextRevenueSalesOfBusiness || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueSalesOfBusiness = val;
      }
    },
    nextRevenueMortgageBrokering: {
      get: function() {
        return this.groupAppraiser.nextRevenueMortgageBrokering || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueMortgageBrokering = val;
      }
    },
    nextRevenueRealEstateConsulting: {
      get: function() {
        return this.groupAppraiser.nextRevenueRealEstateConsulting || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueRealEstateConsulting = val;
      }
    },
    nextRevenueOther: {
      get: function() {
        return this.groupAppraiser.nextRevenueOther || '';
      },
      set: function(val) {
        this.groupAppraiser.nextRevenueOther = val;
      }
    },
    totalNextRevenueOtherServices() {
      return (
        Number(this.groupAppraiser.nextRevenuePropertyManagement) +
        Number(this.groupAppraiser.nextRevenueSalesOfBusiness) +
        Number(this.groupAppraiser.nextRevenueMortgageBrokering) +
        Number(this.groupAppraiser.nextRevenueRealEstateConsulting) +
        Number(this.groupAppraiser.nextRevenueOther)
      ).toFixed(0);
    },
    nextNumberPropertyManagement: {
      get: function() {
        return this.groupAppraiser.nextNumberPropertyManagement || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberPropertyManagement = val;
      }
    },
    nextNumberSalesOfBusiness: {
      get: function() {
        return this.groupAppraiser.nextNumberSalesOfBusiness || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberSalesOfBusiness = val;
      }
    },
    nextNumberMortgageBrokering: {
      get: function() {
        return this.groupAppraiser.nextNumberMortgageBrokering || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberMortgageBrokering = val;
      }
    },
    nextNumberRealEstateConsulting: {
      get: function() {
        return this.groupAppraiser.nextNumberRealEstateConsulting || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberRealEstateConsulting = val;
      }
    },
    nextNumberOther: {
      get: function() {
        return this.groupAppraiser.nextNumberOther || '';
      },
      set: function(val) {
        this.groupAppraiser.nextNumberOther = val;
      }
    },
    totalNextNumberOtherServices() {
      return (
        Number(this.groupAppraiser.nextNumberPropertyManagement) +
        Number(this.groupAppraiser.nextNumberSalesOfBusiness) +
        Number(this.groupAppraiser.nextNumberMortgageBrokering) +
        Number(this.groupAppraiser.nextNumberRealEstateConsulting) +
        Number(this.groupAppraiser.nextNumberOther)
      ).toFixed(0);
    },
    totalLastRevenue() {
      return (
        Number(this.totalLastRevenueResidentialAppraisal) +
        Number(this.totalLastRevenueCommercialAppraisal) +
        Number(this.totalLastRevenueRealEstateSales) +
        Number(this.totalLastRevenueOtherServices)
      ).toFixed(0);
    },
    totalLastNumber() {
      return (
        Number(this.totalLastNumberResidentialAppraisal) +
        Number(this.totalLastNumberCommercialAppraisal) +
        Number(this.totalLastNumberRealEstateSales) +
        Number(this.totalLastNumberOtherServices)
      ).toFixed(0);
    },
    totalNextRevenue() {
      return (
        Number(this.totalNextRevenueResidentialAppraisal) +
        Number(this.totalNextRevenueCommercialAppraisal) +
        Number(this.totalNextRevenueRealEstateSales) +
        Number(this.totalNextRevenueOtherServices)
      ).toFixed(0);
    },
    totalNextNumber() {
      return (
        Number(this.totalNextNumberResidentialAppraisal) +
        Number(this.totalNextNumberCommercialAppraisal) +
        Number(this.totalNextNumberRealEstateSales) +
        Number(this.totalNextNumberOtherServices)
      ).toFixed(0);
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000
          });
        }
      }
    }
  },
  methods: {
    prev() {
      this.$router.push({
        name: "group-appraiser-1"
      });
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = false;
      });
    }
  },

  mounted() {
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {}
};
</script>

<style scoped>
  table td, table th {
    border: 1px solid black;
  }
  table th {
    height: 35px;
  }
  table td:not(:first-child), table th:not(:first-child) {
    text-align: center;
    max-width: 140px;
  }
  table input {
    width: 100%;
    text-align: center;
  }
</style>
